import script from "./PaywallReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallReviews.vue?vue&type=script&setup=true&lang=js"

import "./PaywallReviews.vue?vue&type=style&index=0&id=ac3336e4&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac3336e4"]])

export default __exports__